/**
 * chronos-bulk-pricing.js v3.6 DEBUG (Corrected)
 * 
 * EXACT SAME LOGIC as your current v3.6 file, with comprehensive debug logging
 * added at every step to trace the discount code creation → cart add → discount
 * application flow.
 */
(function () {
  'use strict';

  var WORKER_URL = 'https://chronos-proxy-worker.orange-frog-2d58.workers.dev';

  var dataEl   = document.getElementById('chronos-bulk-pricing-data');
  var wrap     = document.getElementById('chronos-bulk-pricing');
  var listEl   = document.getElementById('cbp-tiers');
  var buyBtn   = document.getElementById('cbp-buy-now-btn');
  var statusEl = document.getElementById('cbp-buy-now-status');
  if (!dataEl || !wrap || !listEl || !buyBtn || !statusEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!DATA || !DATA.variants) return;

  var currentVariantId = String(DATA.current_variant_id || '');
  var _nativeHidden = null;

  function getBulkForm() {
    return wrap.closest('form[action="/cart/add"]');
  }

  function getNativeSubmitButtons() {
    var form = getBulkForm();
    return form
      ? Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], input[type="submit"]'))
      : [];
  }

  function getQty() {
    var form   = getBulkForm();
    var inputs = form ? form.querySelectorAll('input[name="quantity"]') : [];
    var q = null;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].offsetParent !== null) { q = inputs[i]; break; }
    }
    if (!q && inputs.length) q = inputs[0];
    var val = Math.max(1, parseInt((q && q.value) || '1', 10) || 1);
    return val;
  }

  function getVariantId() {
    var form    = getBulkForm();
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    return idInput ? String(idInput.value) : currentVariantId;
  }

  function formatRupees(n) {
    return '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  function _parseMeta(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(Number);
    try { return JSON.parse(val).map(Number); } catch (e) { return []; }
  }

  function buildTierList(entry) {
    var tiers = [{ min: 1, price: entry.base_price }];
    var qArr  = _parseMeta(entry.quantities);
    var pArr  = _parseMeta(entry.prices);
    for (var i = 0; i < qArr.length; i++) {
      tiers.push({ min: qArr[i], price: pArr[i] });
    }
    for (var j = 0; j < tiers.length; j++) {
      tiers[j].max  = (j < tiers.length - 1) ? (tiers[j + 1].min - 1) : Infinity;
      tiers[j].best = (entry.best_qty != null && Number(tiers[j].min) === Number(entry.best_qty));
    }
    return tiers;
  }

  function setNativeButtonsVisible(visible) {
    if (_nativeHidden === !visible) return;
    _nativeHidden = !visible;
    getNativeSubmitButtons().forEach(function (btn) {
      btn.style.display = visible ? '' : 'none';
    });
  }

  function resetBuyNowButton() {
    buyBtn.disabled    = false;
    buyBtn.textContent = 'Order in Bulk';
    statusEl.style.display = 'none';
    statusEl.className     = 'cbp-buy-now-status';
    statusEl.textContent   = '';
  }

  var _lastHasTiers = null;

  function render() {
    var entry    = DATA.variants[currentVariantId];
    var hasTiers = !!(_parseMeta(entry && entry.quantities).length);

    if (!hasTiers) {
      if (_lastHasTiers !== false) {
        wrap.style.display    = 'none';
        buyBtn.style.display  = 'none';
        setNativeButtonsVisible(true);
        _lastHasTiers = false;
      }
      return;
    }

    wrap.style.display = '';
    var tiers = buildTierList(entry);
    var qty   = getQty();
    var qArr  = _parseMeta(entry.quantities);
    var firstTierMin = qArr.length ? qArr[0] : Infinity;
    var qualifies = qty >= firstTierMin;

    listEl.innerHTML = tiers.map(function (t) {
      var active = qty >= t.min && qty <= t.max;
      var label  = (t.max === Infinity)
        ? (t.min + '+ units')
        : (t.min + ' \u2013 ' + t.max + ' units');
      var badge  = t.best ? '<span class="cbp-badge">Top choice</span>' : '';
      return '<div class="cbp-tier-row' + (active ? ' cbp-active' : '') + '">' +
               '<span>' + label + badge + '</span>' +
               '<span class="cbp-tier-price">' + formatRupees(t.price) + ' / unit</span>' +
             '</div>';
    }).join('');

    if (qualifies) {
      setNativeButtonsVisible(false);
      buyBtn.style.display = '';
      statusEl.style.display = 'none';
      statusEl.className = 'cbp-buy-now-status';
      if (!buyBtn.disabled) buyBtn.textContent = 'Order in Bulk';
    } else {
      setNativeButtonsVisible(true);
      buyBtn.style.display = 'none';
      var needed = firstTierMin - qty;
      statusEl.style.display = '';
      statusEl.className = 'cbp-buy-now-status cbp-status-nudge';
      statusEl.textContent = 'Add ' + needed + ' more unit' + (needed === 1 ? '' : 's') + ' to unlock bulk pricing';
    }
    _lastHasTiers = true;
  }

  function setVariant(id) {
    var idStr = String(id);
    if (idStr === currentVariantId) return;
    currentVariantId = idStr;
    render();
  }

  // ── ORDER IN BULK CLICK HANDLER WITH DEBUG LOGGING ──
  buyBtn.addEventListener('click', function () {
    console.group('[DEBUG] ===== ORDER IN BULK FLOW START =====');
    
    var variantId = getVariantId();
    var quantity  = getQty();

    console.log('[DEBUG] Variant ID:', variantId);
    console.log('[DEBUG] Quantity:', quantity);

    if (!variantId) {
      console.error('[DEBUG] No variant ID found');
      console.groupEnd();
      return;
    }

    buyBtn.disabled    = true;
    buyBtn.textContent = 'Preparing your discount…';
    statusEl.style.display = '';
    statusEl.className     = 'cbp-buy-now-status cbp-status-loading';
    statusEl.textContent   = 'Hang on, calculating your bulk price…';

    console.log('[DEBUG] STEP 1: Calling worker');
    fetch(WORKER_URL + '/public/bulk-discount', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ variant_id: variantId, quantity: quantity }),
    })
      .then(function (resp) {
        console.log('[DEBUG] Worker response status:', resp.status);
        return resp.json().then(function (data) {
          console.log('[DEBUG] Worker response data:', data);
          if (!resp.ok || !data || !data.discount_code) {
            throw new Error((data && data.error) || 'Could not calculate your bulk discount');
          }
          return data;
        });
      })
      .then(function (data) {
        console.log('[DEBUG] ✓ Discount code received:', data.discount_code);
        console.log('[DEBUG]   Unit price:', data.unit_price);
        console.log('[DEBUG]   Savings total:', data.savings_total);
        
        buyBtn.textContent   = 'Clearing cart…';
        statusEl.textContent = 'Clearing your cart…';

        console.log('[DEBUG] STEP 2: Calling /cart/clear.js');
        return fetch('/cart/clear.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        }).then(function (clearResp) {
          console.log('[DEBUG] /cart/clear.js response status:', clearResp.status);
          console.log('[DEBUG] ✓ Cart cleared');
          return data;
        });
      })
      .then(function (data) {
        buyBtn.textContent   = 'Adding to cart…';
        statusEl.textContent = 'Adding to your cart…';

        console.log('[DEBUG] STEP 3: Calling /cart/add.js');
        console.log('[DEBUG] Adding item - ID:', parseInt(variantId, 10), 'Quantity:', quantity);
        
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] }),
        }).then(function (cartResp) {
          console.log('[DEBUG] /cart/add.js response status:', cartResp.status);
          return cartResp.json().then(function (cartData) {
            console.log('[DEBUG] /cart/add.js response body:', cartData);
            if (!cartResp.ok) {
              throw new Error((cartData && cartData.description) || 'Could not add to cart');
            }
            console.log('[DEBUG] ✓ Item added to cart');
            return data;
          });
        });
      })
      .then(function (data) {
        console.log('[DEBUG] STEP 4: Saving to sessionStorage');
        try {
          sessionStorage.setItem('chronos_bulk_discount', JSON.stringify({
            variant_id:    variantId,
            quantity:      quantity,
            discount_code: data.discount_code,
          }));
          console.log('[DEBUG] ✓ Saved to sessionStorage');
        } catch (e) {
          console.warn('[DEBUG] Could not save to sessionStorage:', e);
        }

        statusEl.textContent = 'Applying your discount…';

        console.log('[DEBUG] STEP 5: Clearing old discount via /discount/NONE');
        return fetch('/discount/NONE', { redirect: 'manual' })
          .catch(function() { 
            console.log('[DEBUG] /discount/NONE (expected to fail)'); 
          })
          .finally(function() {
            console.log('[DEBUG] STEP 6: Redirecting to apply new discount');
            var discountUrl = '/discount/' + encodeURIComponent(data.discount_code) + '?redirect=/cart';
            console.log('[DEBUG] Redirect URL:', discountUrl);
            console.log('[DEBUG] ✓ Initiating redirect');
            console.groupEnd();
            window.location.href = discountUrl;
          });
      })
      .catch(function (err) {
        console.error('[DEBUG] ✗ ERROR CAUGHT:', err.message);
        console.log('[DEBUG] Stack:', err.stack);
        console.groupEnd();
        statusEl.className   = 'cbp-buy-now-status cbp-status-error';
        statusEl.textContent = 'Something went wrong — please try again, or contact us if it persists.';
        buyBtn.disabled      = false;
        buyBtn.textContent   = 'Order in Bulk';
      });
  });

  // Variant change detection
  document.addEventListener('on:variant:change', function (e) {
    var d = e.detail || {};
    var v = d.variant || (d.id ? d : null);
    if (v && v.id) setVariant(v.id);
  });
  document.addEventListener('variant:changed', function (e) {
    var d = e.detail || {};
    var v = d.variant || (d.id ? d : null);
    if (v && v.id) setVariant(v.id);
  });

  var _polledVid = '';
  setInterval(function () {
    var form = getBulkForm();
    var inp  = form && form.querySelector('input[name="id"]');
    if (inp && inp.value && inp.value !== _polledVid) {
      _polledVid = inp.value;
      setVariant(inp.value);
    }
  }, 300);

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches('input[name="quantity"]')) render();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('input[name="quantity"]')) render();
  });

  (function() {
    var s = document.createElement('style');
    s.textContent = '.cbp-status-nudge{color:#daa520;font-size:13px;text-align:center;margin-top:6px;}';
    document.head.appendChild(s);
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();